module.exports = __webpack_public_path__ + "static/img/erweima.4a60c2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/erweima.jpg
// module id = Yf1S
// module chunks = 1